import { useAuth0 } from "@auth0/auth0-react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import type { ReactNode } from "react";

export default function AuthGuard({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          gap: 3,
        }}
      >
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            bgcolor: "primary.main",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
          }}
        >
          <LockOutlinedIcon fontSize="large" />
        </Box>
        <Typography variant="h5" fontWeight={600}>
          Sign in to Zennet
        </Typography>
        <Typography variant="body2" color="text.secondary">
          You must be signed in to access the portal.
        </Typography>
        <Button variant="contained" size="large" onClick={() => loginWithRedirect()}>
          Sign in
        </Button>
      </Box>
    );
  }

  return <>{children}</>;
}
